import React, { useState, useEffect, useRef } from 'react';
import { DownOutlined, MinusOutlined, PlusOutlined, UploadOutlined } from '@ant-design/icons';
import { Button, Form, Input, Radio, message, Upload, Checkbox, Modal, Dropdown, Select } from 'antd';
import { request } from "@/utils";
import { useLocation, useNavigate, useNavigation } from "react-router-dom";
import "./index.less";
import { convertDateToTimestamp, Func } from "@/utils/func";

import { baseUrl } from "@/utils/request";
import { Option } from 'antd/lib/mentions';


export default function SubOrderCommit() {
    const { TextArea } = Input;
    const [data, setData] = useState({})
    const [detail, setDetail] = useState({})
    const location = useLocation();
    const navigate = useNavigate();
    const state = location.state || {};
    const searchParams = new URLSearchParams(location.search);
    const [childList, setChildList] = useState([])
    const selectChildSn = useRef()
    const [childNum, setChildNum] = useState(0)
    const [is_dietary_restrictions, setIsDietaryRestrictions] = useState(0)
    const [ageList, setAgeList] = useState([
        { label: '1岁', value: 1 },
        { label: '2岁', value: 2 },
        { label: '3岁', value: 3 },
        { label: '4岁', value: 4 },
        { label: '5岁', value: 5 },
        { label: '6岁', value: 6 },
        { label: '7岁', value: 7 },
        { label: '8岁', value: 8 },
        { label: '9岁', value: 9 },
        { label: '10岁', value: 10 },
        { label: '11岁', value: 11 },
        { label: '12岁', value: 12 },
        { label: '13岁', value: 13 },
        { label: '14岁', value: 14 },
        { label: '15岁', value: 15 },
        { label: '16岁', value: 16 }
    ])
    const fetchData = async () => {
        try {
            const response = await request.get('restaurant/detail?id=' + searchParams.get("id"));
            setDetail(response.data || {})
            // console.log(response.data,'--')
        } catch (error) {
            console.error('Failed to fetch data:', error);
        }
    };

    const postData = async (data) => {
        try {
            const response = await request.post('restaurant/reservation_order_create', {
                // ...state?.data,
                reservation_time: state?.data?.reservation_time,
                reservation_number: state?.data?.reservation_number,
                email: data.email,
                adjust: state?.data?.adjust,
                reservation_date: convertDateToTimestamp(state?.data?.reservation_date),
                b1_reservation_date: convertDateToTimestamp(state?.data?.b1_reservation_date),
                b1_reservation_time: state?.data?.b1_reservation_time,
                b1_reservation_number: state?.data?.b1_reservation_number,
                b2_reservation_date: convertDateToTimestamp(state?.data?.b2_reservation_date),
                b2_reservation_time: state?.data?.b2_reservation_time,
                b2_reservation_number: state?.data?.b2_reservation_number,
                meal_id: state?.data?.meal_id,
                restaurant_id: state?.data?.restaurant_id,
                reservation_service_charge: state?.data?.reservation_service_charge,
                meal_deposit: state.data.meal_deposit,
                reservation_total_amount: state.data.reservation_total_amount,
                first_name: data.first_name,
                last_name: data.last_name,
                phone_number: data.phone_number,
                area_code: data.area_code,
                precautions: data.precautions,
                dietary_restrictions: data.dietary_restrictions,
                is_dietary_restrictions: data.is_dietary_restrictions ? true : false,
                seat: state?.data?.seat,
                children_config:data?.children_config
            }); // 使用封装好的Axios实例发送GET请求
            console.log(response, 'response')
            if (response.code) {
                message.error(response.msg)
            } else {
                sessionStorage.setItem('orderId', response.data.id)
                navigate('/pay?id=' + response.data.id + '&sn=' + response.data.reservation_code + '&type=0')
            }
        } catch (error) {
            console.error('Failed to fetch data:', error);
        }
    };

    const onFinish = (values) => {
        console.log('Success:', values);
        if (values.area_code == '86' && !/^1[3-9]\d{9}$/.test(values.phone_number)) {
            message.error('请输入正确的手机号码')
            return
        }
        let flag = 0
        if (childList.length > 0) {
            childList.forEach((v) => {
                if (!v.value) {
                    flag = 1
                }
            })
        }
        if (flag) {
            message.error('请选择儿童年龄')
            return
        }
        if (!values.remember) {
            message.error("请阅读并同意预约协议")
            return
        }

        data.full_name = values.full_name
        data.phone_number = values.phone_number
        data.precautions = values.precautions ? values.precautions : ''
        data.is_dietary_restrictions = values.is_dietary_restrictions
        data.dietary_restrictions = values.dietary_restrictions ? values.dietary_restrictions : ''
        data.email = values.email
        data.first_name = values.first_name
        data.last_name = values.last_name
        data.area_code = values.area_code
        data.children_config = childList?.length==0?'':JSON.stringify(childList.map(v => { return v.value }))
        postData(data)
    };
    const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
        // navigate(-2)
    };

    useEffect(() => {
        fetchData();
        let formData = JSON.parse(sessionStorage.getItem('user'));
        form.setFieldValue('first_name', formData?.first_name)
        form.setFieldValue('last_name', formData?.last_name)
        form.setFieldValue('area_code', formData?.nation_code || '86')
        form.setFieldValue('phone_number', formData?.mobile)
        form.setFieldValue('email', formData?.email)
    }, [])
    const [form] = Form.useForm();
    const selectAge = (val) => {
        console.log(val, childList)
        ageList.forEach((v) => {
            if (v.value == val) {
                v.checked = true
            } else {
                v.checked = false
            }
        })
        childList[selectChildSn.current].value = val
        setChildList([...childList])
        setAgeList([...ageList])
    }
    return (
        <div className="order-commit">
            <div className="order-commit-content">
                <div>
                    <Button type="cancel" style={{ with: "74px", height: "32px", marginTop: "20px", color: "#999999", borderRadius: "4px" }}
                        onClick={() => navigate(-1)}>
                        返回
                    </Button>
                </div>

                <div className="order-commit-info-content">
                    <div className="commit-head">{detail.name}</div>
                    <div className="commit-item">
                        <div className="commit-item-label">预约日期:</div>
                        {state?.data?.reservation_date}  {state?.data?.reservation_time}，{state?.data?.reservation_number}人
                    </div>
                    {
                        state?.data?.adjust && state?.data?.b1_reservation_date &&
                        <div className="commit-item">
                            <div className="commit-item-label">备选时间一:</div>
                            {state?.data?.b1_reservation_date}  {state?.data?.b1_reservation_time}，{state?.data?.b1_reservation_number}人
                        </div>
                    }
                    {
                        state?.data?.adjust && state?.data?.b2_reservation_date && <div className="commit-item">
                            <div className="commit-item-label">备选时间二:</div>
                            {state?.data?.b2_reservation_date}  {state?.data?.b2_reservation_time}，{state?.data?.b2_reservation_number}人
                        </div>
                    }
                    {
                        state?.data?.seat && <div className="commit-item">
                            <div className="commit-item-label">座位类型:</div>
                            {state?.data?.seat}
                        </div>
                    }
                    {
                        state?.data?.meal && <div className="commit-item">
                            <div className="commit-item-label">预约套餐:</div>
                            {state?.data?.meal}
                        </div>
                    }

                </div>
                <div className="commit-notice" style={{ fontSize: "14px" }}>
                    *点击最终确认预约后，日期、时间、人数都将无法修改。
                </div>
                <div className="order-commit-info-content-no-shadow">
                    <div className="commit-desc-head">预约费用</div>
                    <div className="commit-desc-item">
                        <div className="commit-item-label">预约费:</div>
                        ￥{detail.subscription_price}x{state?.data?.reservation_number}
                    </div>
                    <div className="commit-desc-item">
                        <div className="commit-item-label">套餐押金:</div>
                        <div>￥{detail?.meal?.find(item => item.id === state?.data?.meal_id)?.deposit}x{state?.data?.reservation_number}</div>
                        <div style={{color:'#ea0025'}}>（押金不抵扣餐费，用餐后点击“就餐完成”，上传账单小票退款）</div>
                    </div>
                    <div className="commit-desc-item">
                        <div className="commit-item-label">总计:</div>
                        ￥{((detail?.subscription_price * 1 + detail?.meal?.find(item => item.id === state?.data?.meal_id)?.deposit * 1) * state?.data?.reservation_number * 1).toFixed(2)}
                    </div>
                </div>

                <div className="commit-sub-price-desc-content">
                    <div className="font-weight-bold">预约金额说明</div>
                    <div style={{ color: "#666666" }} dangerouslySetInnerHTML={{ __html: detail.subscription_price_remark }}>

                    </div>
                </div>
                <div className="order-commit-info-content-no-shadow">
                    <div className="commit-desc-head">取消费率说明</div>
                    {
                        detail?.cancellation_rate_desc?.map(v => {
                            return <div className="commit-desc-item" style={{ border: 'none' }}>
                                <div className="commit-item-label">{v.day}天内取消：</div>
                                {v.rate}%
                            </div>
                        })
                    }
                </div>

                {detail.cancel_rule &&
                    <div className="order-commit-info-content-no-shadow">
                        <div className="commit-desc-head">取消费率说明</div>
                        {detail.cancel_rule && detail.cancel_rule.map((item) => {
                            return (
                                <>
                                    <div className="commit-desc-item">
                                        <div className="commit-item-label">{item[0]}天内取消:</div>
                                        {item[1]}%
                                    </div>
                                </>
                            )
                        })
                        }
                    </div>
                }
                <Form
                    name="basic"
                    labelCol={{ span: 8 }}
                    wrapperCol={{ span: 16 }}
                    initialValues={{ remember: false }}
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                    autoComplete="off"
                    layout="vertical"
                    style={{ marginTop: "40px" }}
                    form={form}
                >
                    <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                        <Form.Item
                            label="姓"
                            name="last_name"
                            style={{
                                minWidth: "30%",
                                fontWeight: 'bold'
                            }}
                            rules={[
                                { required: true, message: '请输入您的姓!' },
                                { pattern: /^[a-zA-Z\s]+$/, message: '只能输入英文字母!' }
                            ]}
                        >
                            {/* <div className='form-input-style'> */}
                            <Input placeholder="请输入您的姓" style={{ height: '45px' }} maxLength={50} />
                            {/* </div> */}
                        </Form.Item>
                        <Form.Item
                            label="名"
                            name="first_name"
                            style={{
                                minWidth: "30%",
                                fontWeight: 'bold'
                            }}
                            rules={[
                                { required: true, message: '请输入您的姓!' },
                                { pattern: /^[a-zA-Z\s]+$/, message: '只能输入英文字母!' }
                            ]}
                        >
                            {/* <div className='form-input-style'> */}
                            <Input placeholder="请输入您的名" style={{ height: '45px' }} maxLength={50} />
                            {/* </div> */}
                        </Form.Item>
                    </div>
                    <Form.Item
                        label="手机号码"
                        name="phone_number"
                        style={{
                            width: "75%",
                            // fontWeight: 'bold',
                            fontSize: "16px",
                        }}
                        rules={[{ required: true }]}
                    >
                        {/* <div className="form-input-style">
                            <Dropdown trigger={['click']} menu={{
                                items: [
                                    {
                                        key: '86',
                                        label: (<div onClick={() => { setPhoneCode('86') }}>+86</div>),
                                    },
                                    {
                                        key: '886',
                                        label: (<div onClick={() => { setPhoneCode('886') }}>+886</div>),
                                    },
                                    {
                                        key: '852',
                                        label: (<div onClick={() => { setPhoneCode('852') }}>+852</div>),
                                    },
                                ]
                            }}

                                placement="bottom">
                                <div className='form-input-code'><span>+{phoneCode}</span> <DownOutlined /></div>
                            </Dropdown>
                            <input placeholder="请输入手机号码" />
                        </div> */}
                        <Input.Group compact>
                            <Form.Item
                                name={['area_code']}
                                noStyle
                                rules={[{ required: true, message: '请选择区号' }]}
                            >
                                <Select placeholder="请输入区号">
                                    <Option value="86">+86 中国</Option>
                                    <Option value="886">+886 中国台湾</Option>
                                    <Option value="852">+852 中国香港</Option>
                                    <Option value="853">+853 中共澳门</Option>
                                    <Option value="81">+81 日本</Option>
                                </Select>
                            </Form.Item>
                            <Form.Item
                                name={['phone_number']}
                                noStyle
                                rules={[{ required: true, message: '请输入手机号码' }]}
                            >
                                <Input style={{ width: '50%', height: '45px' }} placeholder="请输入手机号码" />
                            </Form.Item>
                        </Input.Group>
                    </Form.Item>
                    <Form.Item
                        label="邮箱"
                        name="email"
                        style={{
                            width: "75%",
                            fontWeight: 'bold'
                        }}
                        rules={[
                            { required: true },
                            () => ({
                                validator(_, value) {
                                    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
                                    if (!value || emailRegex.test(value)) {
                                        return Promise.resolve();
                                    }
                                    return Promise.reject(new Error('请输入有效的邮箱地址!'));
                                },
                            }),
                        ]}
                    >
                        {/* <div className='form-input-style'> */}
                        <Input placeholder="请输入您的邮箱" style={{ height: '45px' }} maxLength={50} />
                        {/* </div> */}
                    </Form.Item>
                    <Form.Item label="是否有忌口"
                        labelCol={{ span: 6 }}
                        wrapperCol={{ offset: 0, span: 18 }}
                        style={{
                            // width: "500px",
                            fontWeight: 'bold',
                            fontSize: "16px"
                        }} name="is_dietary_restrictions" rules={[{ required: true, message: '请选择是否忌口' }]} wrapperCol={{ offset: 0, span: 24 }}>
                        <Radio.Group
                            style={{ marginBottom: '10px' }}
                            // value={is_dietary_restrictions}
                            options={[
                                { value: 0, label: '否' },
                                { value: 1, label: '是' },
                            ]}
                            onChange={(e) => {
                                setIsDietaryRestrictions(e.target.value)
                            }}
                        />
                    </Form.Item>
                    {
                        !!form.getFieldsValue().is_dietary_restrictions &&
                        <Form.Item label=""
                            style={{
                                fontWeight: 'bold',
                                fontSize: "16px"
                            }}
                            name="dietary_restrictions" wrapperCol={{ offset: 0, span: 24 }}>
                            <TextArea placeholder="请输入过敏、或是近期需控制食用的食材相关内容"
                                maxLength={100}
                                style={{
                                    width: "100%",
                                    height: "120px",
                                    lineHeight: "14px",
                                    paddingTop: "12px"
                                }} />
                        </Form.Item>
                    }
                    <Form.Item label="携带儿童数"
                        labelCol={{ span: 6 }}
                        wrapperCol={{ offset: 0, span: 18 }}
                        style={{
                            // width: "500px",
                            fontWeight: 'bold',
                            fontSize: "16px"
                        }} name="is_with_ children" wrapperCol={{ offset: 0, span: 24 }}>
                        <div className="sub-num">
                            <div className="step-num">
                                <div className="reduce" onClick={() => {
                                    if (childNum > 0) {
                                        setChildNum(childNum - 1)
                                        childList.pop()
                                        setChildList([...childList])
                                    }
                                }}><MinusOutlined /></div>
                                <div className="num">{childNum}</div>
                                <div className="add" onClick={() => {
                                    if (state?.data?.reservation_number * 1 <= childNum) {
                                        message.error('携带儿童数不能大于总人数')
                                        return
                                    }
                                    setChildNum(childNum + 1)
                                    childList.push({ value: null })
                                    setChildList([...childList])
                                }}><PlusOutlined /></div>
                            </div>
                        </div>
                    </Form.Item>
                    <div className="selectAge" >
                        {
                            childList?.map((v, i) => {
                                return <div key={i} className="item">
                                    <div className="title">第{i + 1}位儿童年龄</div>
                                    <Select
                                        onClick={() => {
                                            selectChildSn.current = i
                                        }}
                                        style={{ width: '240px' }}
                                        placeholder="请选择儿童年龄" options={[...ageList]}
                                        onChange={(value) => {
                                            selectAge(value)
                                        }}
                                    />
                                </div>
                            })
                        }
                    </div>

                    <Form.Item label="注意事项" style={{
                        fontWeight: 'bold',
                        fontSize: "16px"
                    }} name="precautions" wrapperCol={{ offset: 0, span: 24 }}>
                        <TextArea placeholder="请输入您在意的内容"
                            maxLength={100}
                            style={{
                                width: "100%",
                                height: "120px",
                                lineHeight: "14px",
                                paddingTop: "12px"
                            }} />
                    </Form.Item>


                    <div className="commit-agreement">
                        <Form.Item name="remember" valuePropName="checked" wrapperCol={{ offset: 0, span: 16 }}
                            style={{ marginLeft: "20px", display: "inline-block", marginBottom: 0 }}>
                            <Checkbox className="commit-agreement-section" />
                        </Form.Item>
                        <div style={{ marginLeft: "10px", display: "inline-block", marginBottom: 0, height: "25px", lineHeight: "32px" }}>
                            <span>我已阅读并同意</span> <span
                                className="commit-agreement-font" onClick={() => { window.open("/userAgreement?typ=4", "_blank") }}>《预约协议》</span>
                        </div>
                    </div>

                    <Form.Item >
                        <div style={{ marginTop: "16px", display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <Button type="cancel" htmlType="cancel"
                                style={{ width: "120px", height: "48px", marginRight: "10px", color: "#666666", borderRadius: "4px" }} onClick={() => {
                                    navigate(-2);
                                }} >

                                取消预约
                            </Button>
                            <Button type="primary" htmlType="submit"
                                style={{ width: "120px", height: "48px", marginLeft: "10px", borderRadius: "4px" }}>
                                提交预约申请
                            </Button>
                        </div>
                    </Form.Item>
                </Form>
            </div>
        </div>
    )
}
